import { PublicShopPage } from '../../views/PublicShop';
import ProductSingle from '../../views/ProductSingle';
import { Panier } from '../../components/organisms/Panier';
import Commande from '../../views/Commande';
import pages from '../pages';
import { Route } from '../routes';
import PublicShopRecapCommande from '../../views/PublicShopRecapCommande';
import PublicShopInfo from '../../views/PublicShopInfo';

export const publicShopRoutes: Route[] = [
  {
    path: pages.PUBLIC_SHOP_HOME.path,
    component: PublicShopPage
  },
  {
    path: pages.PUBLIC_SHOP__SINGLE_PRODUCT.path,
    component: ProductSingle
  },
  {
    path: pages.PUBLIC_SHOP_PANIER.path,
    component: Panier
  },
  {
    path: pages.PUBLIC_SHOP_COMMANDE.path,
    component: Commande
  },
  {
    path: pages.PUBLIC_SHOP_RECAP_COMMANDE.path,
    component: PublicShopRecapCommande
  },
  {
    path: pages.PUBLIC_SHOP_INFO.path,
    component: PublicShopInfo
  }
];
